import SweetAlert2 from 'react-sweetalert2';
import React, {FC, useEffect, useState} from "react";
import ImageGallery  from "react-image-gallery";
import {Box, Dialog, DialogContent, DialogTitle, IconButton, Theme, Typography, useMediaQuery} from "@material-ui/core";
import {AccessibilityUnit} from "../../../../../../../../../../../models/AccessibilityUnits";
import {useSelector} from "../../../../../../../../../../../redux/store";
import {AppStateType} from "../../../../../../../../../../../redux/reducers";
import {fetchUnitImagesByProperty} from "../../../../../../../../../../../services/imageService";
import {useParams} from "react-router-dom";
import {AccessibilityImages} from "../../../../../../../../../../../models/AccessibilityImages";
import {fetchUnits} from "../../../../../../../../../../../services/unitsService";
import styled from "@emotion/styled";
import CloseIcon from "@mui/icons-material/Close";
import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material";

const IconStyle = `
  position: absolute !important;
  z-index: 15000000;
  top: 50%;
  fill: white;
  transform: translateY(-50%);  
  background-color: rgba(0, 0, 0, 0.4) !important;
  width: 45px;
  height: 45px;
  &:focus {
    outline: none;
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.9) !important;
  }
`;

const TopBar = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: relative;
    .MuiButtonBase-root {
        width: 42px;
        color: rgba(18, 22, 25, 0.5);
    }
`

const carret = {
  left: 'https://ams-dev1.s3.eu-west-1.amazonaws.com/ams-widget-icons/CarretLeft.svg',
  right: 'https://ams-dev1.s3.eu-west-1.amazonaws.com/ams-widget-icons/CarretRight.svg'
}


const LeftIcon = styled(IconButton)`
  ${IconStyle};
  left:5px;
`;
const RightIcon = styled(IconButton)`
  ${IconStyle};
  right: 5px;
`;

type PropsType = {
  show: boolean;
  onClose: () => void
}

const PreviewModal: FC<PropsType> = ({show, onClose}) => {
  const params: {id: string} = useParams()
  const theme = useTheme();
  const user = useSelector((state) => state.authReducer.user);
  const [images, setImages] = useState<AccessibilityImages[] | null>(null)
  const [units, setUnits] = useState<AccessibilityUnit[] | null>(null)
  const [previewImages, setPreviewImages] = useState<[]>([])
  const property = useSelector((state: AppStateType) => state.propertyReducer.property)!
  const { t } = useTranslation()
  const isNotDesktop = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    if (show) {
      fetchUnitImagesByProperty(user!.token, params.id).then((response: any) => {
        setImages(response.results)
      })
      fetchUnits(params.id, user!.token).then((response: any) => {
        setUnits(response.data.results)
      })
    }
  }, [show]);

  useEffect(() => {
    if (images && units) {
      if (units.length > 0) {
        const filteredUnits = units.filter((u) => u.is_active)
        let preparedList: any = []
        if (filteredUnits.length > 0) {
          const result: any = []
          // @ts-ignore
          const sortUnits = filteredUnits.sort((a,b) => a.order - b.order)
          sortUnits.forEach((unit) => {
            const filterImagesByUnit = images
              .filter((image) => unit.id === image.accessibility_unit && image.is_display_in_output_service)
            const sortedImages = filterImagesByUnit.sort((a,b) => a.order - b.order)
            result.push(...sortedImages)
          })

          preparedList = result.map((item: any) => ({
            original: item.thumbnails.large,
            thumbnail: item.thumbnails.small,
            description: item.description
          }))
        }
        if (property.general_image) {
          preparedList.unshift({
            original: property.general_image,
            thumbnail: property.general_image,
            description: property.general_image_description
          })
        }
        setPreviewImages(preparedList)
      }
    }

  }, [images, units]);

  return (
    <Dialog
      open={show}
      onClose={onClose}
      fullScreen={isNotDesktop}
      PaperProps={{
        style: {
          borderRadius: isNotDesktop ? 0 : '8px',
        },
      }}
      className={'preview-modal'}
    >
      <TopBar>
        <DialogTitle disableTypography>
          <Typography variant="h4" align="center" >{t('preview')}</Typography>
        </DialogTitle>
        <IconButton
          style={{position: 'absolute', top: '10px', right: '10px'}}
          edge="start"
          color="inherit"
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon style={{color: 'gray'}}/>
        </IconButton>
      </TopBar>
      <DialogContent style={{padding: '24px'}}>
        <ImageGallery
          items={previewImages}
          showPlayButton={false}
          infinite={false}
          renderLeftNav={(onClick, disabled) => {
            if (disabled) {
              return null;
            }
            return (
              <LeftIcon
                onClick={onClick}
                disabled={disabled}
              >
                <img src={carret.left} height={15} width={15}/>
              </LeftIcon>
            );
          }}
          renderRightNav={(onClick, disabled) => {
            if (disabled) {
              return null;
            }
            return (
              <RightIcon
                onClick={onClick}
                disabled={disabled}
              >
                <img src={carret.right} height={15} width={15}/>
              </RightIcon>
            );
          }}
        />
      </DialogContent>
    </Dialog>
  )
}

export default PreviewModal